import React from 'react';
import { Checkbox, Col, Divider, Row, Select } from 'antd';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';
import moment from 'moment';

import { FlexContainer } from 'components/Layout/common';
import Label from 'components/Text/Label';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';
import { TUtilsTypes } from 'utils/globalTranslation/TModules';

const Birthday: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const { t } = useMultiLanguageTranslation();

  return (
    <>
      <FlexContainer>
        <label style={{ marginBottom: 8 }}>
          {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.Includes`)}
        </label>
        <Select
          mode="multiple"
          value={_get(values, 'filters.birthmonth[0].criteria[0].values')}
          showArrow={true}
          allowClear
          placeholder={t(
            `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.SelectBirthMonth`
          )}
          onChange={values => {
            setFieldValue('filters.birthmonth[0].criteria[0].values', values);
          }}
          filterOption={(inputValue, option) =>
            (option.props.children as string).toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
          data-testid="birthmonth-select"
        >
          {moment.months().map((month, index) => {
            return (
              <Select.Option key={index} value={String(index + 1)}>
                {t(`${TUtilsTypes}.${month}`)}
              </Select.Option>
            );
          })}
        </Select>
      </FlexContainer>
      <Divider />
      <Row>
        <Col span={12}>
          <div className="spaced">
            <Label dark bold>
              {t(
                `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.CurrentBirthMonth`
              )}
            </Label>
          </div>
          <FlexContainer>
            <Checkbox
              checked={values.filters?.current_birthmonth?.[0]?.criteria?.[0]?.values || false}
              onChange={evt => {
                setFieldValue('filters.current_birthmonth', [
                  {
                    type: 'current_birthmonth',
                    criteria: [{ values: evt.target.checked }]
                  }
                ]);
              }}
            >
              {t(
                `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.OnlyDuringMonthOfBirth`
              )}
            </Checkbox>
          </FlexContainer>
        </Col>
        <Col span={12}>
          <div className="spaced">
            <Label dark bold>
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.HasBirthday`)}
            </Label>
          </div>
          <FlexContainer>
            <Checkbox
              checked={values.filters?.current_birthday?.[0]?.criteria?.[0]?.values || false}
              onChange={evt => {
                setFieldValue('filters.current_birthday', [
                  {
                    type: 'current_birthday',
                    criteria: [{ values: evt.target.checked }]
                  }
                ]);
              }}
            >
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.BirthdayFilter.OnBirthday`)}
            </Checkbox>
          </FlexContainer>
        </Col>
      </Row>
    </>
  );
};

export default Birthday;
